import service from '@/services/analytics';

export default {
  loadStatistics: ({ commit }, payload = {}) => {
    return service.getStatistics(payload).then(response => {
      return commit('loadStatisticsSuccess', response);
    });
  },
  loadInfluencedOrders: ({ commit, state }) => {
    return service.getInfluencedOrders(state.influencedOrders.pagination).then(response => {
      return commit('loadInfluencedOrdersSuccess', response);
    });
  },
  setPagination({ commit }, payload) {
    commit('setPagination', payload);
  },
  setItems({ commit }, payload) {
    commit('setItems', payload);
  },
  loadCouponInfluencedOrders: ({ commit, state }) => {
    return service
      .getCouponInfluencedOrders(state.couponInfluencedOrders.pagination)
      .then(response => {
        return commit('loadCouponInfluencedOrdersSuccess', response);
      });
  },
  setCouponPagination({ commit }, payload) {
    commit('setCouponPagination', payload);
  },
  loadReviewsPerPeriod({ commit, state }) {
    service
      .getReviewsPerPeriod(state.reviewsPerPeriod.period)
      .then(response => commit('loadReviewsPerPeriodSuccess', response));
  },
  loadReviewRequestsMonthlyStats: ({ commit, state }) => {
    service
      .getReviewRequestsMonthlyStats(state.reviewRequestsMonthlyStats.months)
      .then(response => {
        const finalValue = [];
        response.map(year => {
          const keys = Object.keys(year);
          keys.map(key => {
            year[key].map(month => {
              const tmp = Object.entries(month);
              finalValue.push({
                year: key,
                monthIndex: tmp[0][0],
                completed: tmp[0][1].completed,
                opened: tmp[0][1].opened,
                sent: tmp[0][1].sent,
              });
            });
          });
        });
        commit('loadReviewRequestsMonthlyStatsSuccess', finalValue);
      });
  },
  // NEW STATS
  // format of dates is YYYY-MM-DD
  loadDailyInfluencedOrderStats: ({ commit }, payload) => {
    service.getDailyInfluencedOrderStats(payload.fromDate, payload.toDate).then(response => {
      return commit('loadDailyInfluencedOrderStatsSuccess', response);
    });
  },
  loadDailyReviewStats: ({ commit }, payload) => {
    commit('setStatsLoaded', false);
    service
      .getDailyReviewStats(payload.fromDate, payload.toDate)
      .then(response => {
        return commit('loadDailyReviewStatsSuccess', response);
      })
      .catch(() => {});
  },
  loadDailyCouponInfluencedStats: ({ commit }, payload) => {
    return service
      .getCouponInfluencedStats(payload.fromDate, payload.toDate)
      .then(response => {
        return commit('loadDailyCouponInfluencedStatsSuccess', response);
      })
      .catch(() => {});
  },
  loadDailyReviewRequestStats: ({ commit }, payload) => {
    service.getDailyReviewRequestStats(payload.fromDate, payload.toDate).then(response => {
      return commit('loadDailyReviewRequestStatsSuccess', response);
    });
  },
  loadDailyCouponStats: ({ commit }, payload) => {
    service.getDailyCouponStats(payload.fromDate, payload.toDate).then(response => {
      return commit('loadDailyCouponStatsSuccess', response);
    });
  },
};
